import {
  ICountryStrategy,
  ICountryFieldConfig,
  FIELD_USER_NAME,
  FIELD_ALIAS,
  FIELD_BUSINESS_NAME,
  FIELD_RUC,
  FIELD_COMMERCIAL_ADDRESS,
} from "../../interfaces/countryStrategy";
import {
  COUNTRY_PAN,
  COUNTRY_PANAMA,
  ERRORS_MESSAGES,
} from "../../utils/constants";

const panamaFields: ICountryFieldConfig[] = [
  FIELD_USER_NAME,
  FIELD_ALIAS,
  FIELD_BUSINESS_NAME,
  {
    ...FIELD_RUC,
    order: 4,
  },
  {
    ...FIELD_COMMERCIAL_ADDRESS,
    order: 5,
  },
];

export const panamaStrategy: ICountryStrategy = {
  code: COUNTRY_PAN,
  name: COUNTRY_PANAMA,
  fields: panamaFields,

  getValidations: () => [
    {
      id: "userName",
      type: "required",
      message: ERRORS_MESSAGES.contactNameRequired,
    },
    {
      id: "name",
      type: "required",
      message: ERRORS_MESSAGES.nameRequired,
    },
    {
      id: "businessName",
      type: "required",
      message: ERRORS_MESSAGES.businessNameRequired,
    },
    {
      id: "cuit",
      type: "required",
      message: ERRORS_MESSAGES.rucRequired,
    },
    {
      id: "commercialAddress",
      type: "required",
      message: ERRORS_MESSAGES.commercialAddressRequired,
    },
  ],

  transformSubmitData: (data) => ({
    ...data,
    cuit: (data.cuit as string).replace(/[^0-9]/g, ""),
  }),
};
